import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_nigerian-bold/artifacts/7jbs9qu8_e9958e44-df5e-44f3-94f5-44748d456eb2.png";

// Official Aradelá brand logo — chili pepper + "Aradelá" wordmark on a black background
// that blends seamlessly with the dark navbar.
export const Wordmark = ({ size = "md", className = "" }) => {
  const sizes = {
    xs: "h-10",
    sm: "h-14",
    md: "h-20",
    lg: "h-28",
    xl: "h-32",
    "2xl": "h-40",
    "3xl": "h-44",
  };
  return (
    <img
      src={LOGO_URL}
      alt="Aradelá"
      draggable={false}
      className={`${sizes[size] || sizes.md} w-auto object-contain select-none ${className}`}
      data-testid="brand-logo"
    />
  );
};

// Compact chili icon — uses the same logo image with horizontal crop.
export const ChiliLogo = ({ size = 36, className = "" }) => (
  <img
    src={LOGO_URL}
    alt=""
    aria-hidden="true"
    draggable={false}
    style={{ height: size, width: "auto", objectFit: "contain", objectPosition: "left center" }}
    className={`select-none ${className}`}
  />
);
